import * as actionTypes from "./actionTypes";

export const getAssetAction = (storeId) => {
  return { type: actionTypes.GET_ASSETS, storeId };
};

export const addAssetAction = (asset) => {
  return { type: actionTypes.ADD_ASSET, asset };
};

export const editAssetAction = (asset) => {
  return { type: actionTypes.EDIT_ASSET, asset };
};

export const deleteAssetAction = (assetid, storeid) => {
  return { type: actionTypes.DELETE_ASSET, asset: { assetid, storeid } };
};

export const modifyAssetAction = (assets) => {
  return { type: actionTypes.MODIFY_ASSETS, assets };
};
